/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * Determines how the SSO login page is presented to the user; defaults to popup.
 * @export
 */
export const SSOUXMode = {
    Popup: 'popup',
    Redirect: 'redirect'
} as const;
export type SSOUXMode = typeof SSOUXMode[keyof typeof SSOUXMode];


export function SSOUXModeFromJSON(json: any): SSOUXMode {
    return SSOUXModeFromJSONTyped(json, false);
}

export function SSOUXModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SSOUXMode {
    return json as SSOUXMode;
}

export function SSOUXModeToJSON(value?: SSOUXMode | null): any {
    return value as any;
}

